import * as React from "react";

import { CHECKOUT_CART_PATH } from "../../constants/Paths";
import { Redirect } from "react-router-dom";

const RedirectToCart = () => <Redirect to={CHECKOUT_CART_PATH} />;

export { RedirectToCart };
